import { STORAGE_KEYS } from './constants.js';

/**
 * LocalStorageから会話データを読み込み
 * @returns {Array} 会話配列
 */
export const loadConversations = () => {
  const savedConversations = localStorage.getItem(STORAGE_KEYS.conversations);
  return savedConversations ? JSON.parse(savedConversations) : [];
};

/**
 * LocalStorageに会話データを保存
 * @param {Array} conversations - 会話配列
 */
export const saveConversations = (conversations) => {
  if (conversations.length > 0) {
    localStorage.setItem(STORAGE_KEYS.conversations, JSON.stringify(conversations));
  }
};

/**
 * LocalStorageからAPIキーを読み込み
 * @returns {string|null} APIキー
 */
export const loadApiKey = () => {
  return localStorage.getItem(STORAGE_KEYS.apiKey);
};

/**
 * LocalStorageにAPIキーを保存
 * @param {string} apiKey - APIキー
 */
export const saveApiKey = (apiKey) => {
  localStorage.setItem(STORAGE_KEYS.apiKey, apiKey);
};

/**
 * 新しい会話オブジェクトを作成
 * @param {string} initialMessage - 初期メッセージ
 * @returns {Object} 新しい会話オブジェクト
 */
export const createNewConversationObject = (initialMessage) => {
  return {
    id: Date.now().toString(),
    title: '新しい会話',
    summary: null,
    messages: [
      {
        id: Date.now().toString(),
        role: 'assistant',
        content: initialMessage,
        timestamp: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  };
};

/**
 * 新しいメッセージオブジェクトを作成
 * @param {string} content - メッセージ内容
 * @param {string} role - 役割 ('user' | 'assistant')
 * @returns {Object} 新しいメッセージオブジェクト
 */
export const createMessageObject = (content, role) => {
  return {
    id: Date.now().toString(),
    role,
    content: content.trim(),
    timestamp: new Date()
  };
};